import useUser from '@/grandus-lib/hooks/useUser';
import VAT from '@/utils/vat';
import get from 'lodash/get';
import { useTranslation } from '@/app/i18n/client';

const PriceDynamic = ({ priceData }) => {
  const { user } = useUser();
  const isVatPrimary = VAT.isVatPrices(user);
  const { t } = useTranslation();

  if (!priceData) {
    return '';
  }

  const priceKey = isVatPrimary ? 'priceWithoutVatFormatted' : 'priceFormatted';

  return (
    <div>
      <span className={'whitespace-nowrap'}>
        {get(priceData, priceKey, '')}
      </span>

      <br />
      <span className={'text-xs text-grey3'}>
        {isVatPrimary ? t('price.vat_not_included') : t('price.vat_included')}
      </span>
    </div>
  );
};

export default PriceDynamic;